export const normalizePaymentType = (paymentType, paymentTypes = []) => {
  const value = paymentType?.name ?? paymentType?.id ?? paymentType
  const paymentTypeOption = paymentTypes.find(item => item.id === value)

  return paymentTypeOption ? paymentTypeOption.name.toLowerCase() : typeof value === 'string' ? value.toLowerCase() : value
}

export const normalizePaymentTypes = (paymentTypes = [], paymentTypeOptions = []) =>
  paymentTypes.map(item => normalizePaymentType(item, paymentTypeOptions))
